import { render, staticRenderFns } from "./CommunicationsSection.vue?vue&type=template&id=8f8ed9be&scoped=true&lang=pug"
import script from "./CommunicationsSection.vue?vue&type=script&lang=js"
export * from "./CommunicationsSection.vue?vue&type=script&lang=js"
import style0 from "./CommunicationsSection.styl?vue&type=style&index=0&id=8f8ed9be&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f8ed9be",
  null
  
)

export default component.exports